import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisCollectionsRoute: InvariantJiraRoute = {
	name: 'polaris-collections',
	path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
	query: ['projects?', 'owners?'],
	exact: true,
};
